import { playSound } from './sounds';
// Feu d'artifice plein écran (canvas) joué lors d'un nouveau record de charge
const COLORS = ['#10b981', '#34d399', '#fbbf24', '#f59e0b', '#60a5fa', '#f472b6', '#ffffff'];

function burst(particles, x, y) {
  const color = COLORS[Math.floor(Math.random() * COLORS.length)];
  const count = 60 + Math.floor(Math.random() * 30);
  for (let i = 0; i < count; i += 1) {
    const angle = (Math.PI * 2 * i) / count + Math.random() * 0.2;
    const speed = 2 + Math.random() * 5;
    particles.push({
      x, y, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed,
      life: 1, decay: 0.012 + Math.random() * 0.012, color, size: 1.5 + Math.random() * 2,
    });
  }
}

export function launchFireworks({ duration = 3200 } = {}) {
  if (typeof document === 'undefined') return;
  const canvas = document.createElement('canvas');
  canvas.className = 'fireworks-canvas';
  const dpr = window.devicePixelRatio || 1;
  const w = window.innerWidth;
  const h = window.innerHeight;
  canvas.width = w * dpr;
  canvas.height = h * dpr;
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  if (!ctx) { canvas.remove(); return; }
  ctx.scale(dpr, dpr);

  const particles = [];
  const start = performance.now();
  let lastBurst = 0;

  const frame = (now) => {
    const elapsed = now - start;
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'rgba(0,0,0,0.18)';
    ctx.fillRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'lighter';

    if (elapsed < duration - 800 && now - lastBurst > 260) {
      burst(particles, w * (0.15 + Math.random() * 0.7), h * (0.15 + Math.random() * 0.4));
      lastBurst = now;
    }
    for (let i = particles.length - 1; i >= 0; i -= 1) {
      const p = particles[i];
      p.x += p.vx; p.y += p.vy; p.vy += 0.06; p.vx *= 0.985; p.vy *= 0.985; p.life -= p.decay;
      if (p.life <= 0) { particles.splice(i, 1); continue; }
      ctx.globalAlpha = Math.max(p.life, 0);
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    if (elapsed < duration || particles.length) requestAnimationFrame(frame);
    else canvas.remove();
  };
  requestAnimationFrame(frame);

  if (navigator.vibrate) navigator.vibrate([80, 40, 120]);
}

export function showRecordBanner(text) {
  const el = document.createElement('div');
  el.className = 'record-banner';
  el.innerHTML = '<div class="record-banner-title">🏆 NOUVEAU RECORD !</div><div class="record-banner-sub"></div>';
  el.querySelector('.record-banner-sub').textContent = text;
  document.body.appendChild(el);
  setTimeout(() => el.classList.add('record-banner--out'), 2600);
  setTimeout(() => el.remove(), 3200);
}

export function celebrateRecord(text) {
  playSound('record');
  launchFireworks();
  showRecordBanner(text);
}
